<template>
  <v-container fill-height :class="mainClass">
    <v-row justify="center" align="center">
      <v-col align="center" cols="12">
        <v-progress-circular indeterminate :color="color" :size="size">
          <v-img :max-width="size - 20" :src="logo" />
        </v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  computed: {
    size() {
      return this.$vuetify.breakpoint.mobile ? 100 : 200
    },
    color() {
      return this.$vuetify.breakpoint.mobile ? 'white' : 'primary'
    },
    mainClass() {
      return this.$vuetify.breakpoint.mobile ? ['primary'] : []
    },
    logo() {
      return this.$vuetify.breakpoint.mobile
        ? 'https://cdn.salescloud.is/logo_white.svg'
        : 'https://cdn.salescloud.is/logo.svg'
    }
  }
}
</script>
